export default "__VITE_ASSET__DnZ9Tt9G__"